import { useState } from 'react';
import { FCRAWorkerCheckRecord } from '@/types/turn-api';

const useDiagramTreeModal = () => {
  const [isDiagramTreeOpen, setIsDiagramTreeOpen] = useState(false);
  const [diagramTreeData, setDiagramTreeData] = useState<FCRAWorkerCheckRecord.V6>(null);

  const handleOpenDiagramTree = (data: FCRAWorkerCheckRecord.V6) => {
    setDiagramTreeData(data);
    setIsDiagramTreeOpen(true);
  };

  const handleCloseDiagramTree = () => {
    setIsDiagramTreeOpen(false);
    setDiagramTreeData(null);
  };

  return {
    diagramTreeData,
    handleCloseDiagramTree,
    handleOpenDiagramTree,
    isDiagramTreeOpen,
  };
};

export default useDiagramTreeModal;
